import { IconButton, SvgIcon } from "@mui/material";
import { CustomTooltip } from "@web-applications/allinga-web-components";
import { ElementType, MouseEvent } from "react";
import { TTSCustomEditorColors } from "shared/constants";
import { EditorButtonStyles } from "shared/models";
import { ttsCustomEditorStyles } from "styles/tts-custom-editor-styles";

interface IconButtonWithTooltipProps {
  tooltip: string;
  id: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  icon: ElementType;
  color?: string;
  buttonStyles?: EditorButtonStyles;
  isActive?: boolean;
  disabled?: boolean;
}

export default function IconButtonWithTooltip({
  tooltip,
  id,
  onClick,
  icon,
  disabled = false,
  color = TTSCustomEditorColors.ToolbarIconColor,
  buttonStyles,
  isActive = false,
}: IconButtonWithTooltipProps): JSX.Element {
  return (
    <CustomTooltip
      placement="bottom"
      title={tooltip}
      disableHoverListener={false}
      forceShow
    >
      <IconButton
        id={id}
        onClick={onClick}
        disableRipple
        sx={{
          ...buttonStyles,
          height: "32px",
          width: "32px",
          p: isActive ? 0.5 : 1,
          borderRadius: "4px",
          backgroundColor: isActive ? "lightblue" : "transparent",
          "&:hover": { backgroundColor: "action.hover", borderRadius: "50%" },
          color: color,
        }}
        disabled={disabled}
      >
        <SvgIcon
          sx={{
            ...ttsCustomEditorStyles.toolbarIconSize,
            color,
            "&:hover": { backgroundColor: "transparent" },
          }}
          component={icon}
        />
      </IconButton>
    </CustomTooltip>
  );
}
